export interface ModalContent {
  title?: string;
  message?: string;
  confirmationBtnText?: string;
  declineBtnText?: string;
}

export const deleteModalContent: ModalContent = {
  title: $localize`Potwierdzanie usunięcia`,
  message: $localize`Czy na pewno chcesz usunąć ten rekord?`,
  confirmationBtnText: $localize`Tak`,
  declineBtnText: $localize`Nie`,
};

export const leaveFormModalContent: ModalContent = {
  title: $localize`Opuszczanie formularza`,
  message: $localize`Czy na pewno chcesz opuścić formularz? Zmiany nie zostaną zapisane.`,
  confirmationBtnText: $localize`Tak`,
  declineBtnText: $localize`Nie`,
};

export const confirmModalContent: ModalContent = {
  title: $localize`Potwierdzanie operacji`,
  message: $localize`Czy na pewno chcesz wykonać tę operację?`,
  confirmationBtnText: $localize`Tak`,
  declineBtnText: $localize`Nie`,
};

export const basicConfirmModalContent: ModalContent = {
  title: $localize`Potwierdzanie operacji`,
  message: $localize`Czy na pewno chcesz to zrobić?`,
  confirmationBtnText: $localize`Tak`,
  declineBtnText: $localize`Nie`,
};
